import { PRIVATE_HTTP as http } from "../http-common";

const products = async () => {
  return http().get(`/api/v4/products`);
};

const myProducts = async () => {
  return http().get(`/api/v4/products/me`);
};

export { products, myProducts };
